import React from 'react';
import {IOddsComparisonTableEvent} from "./OddsComparisonTable";
import {DateTime} from "luxon";
import CountryFlag from "./CountryFlag";
import bn from "../utils/bemnames";
import {EventStatus} from "../utils/types";
import {formatEventTitle} from "../utils/event";

const bem = bn.create('odds-comp');

interface IProps {
  event: IOddsComparisonTableEvent;
  showTeamLogos: boolean;
  isMobile: boolean;
}

const OddsComparisonEventDateAndName: React.FC<IProps> = ({event, showTeamLogos, isMobile}) => {
  return (
    <>
      <div className={bem.e('event-date')}>
        <div>
          {DateTime.fromISO(event.userStartTime).toLocaleString(DateTime.TIME_24_SIMPLE)}
        </div>
        {event.status === EventStatus.Inprogress && (
          <div>
            <span className={bem.e('live')}/>
          </div>
        )}
      </div>
      <div>
        <div className={bem.e('event-description')}>
          {showTeamLogos ?
            <div className={bem.e('event-flag')}>
              {
                (event.homeIsNationalTeams && event.homeRegionName)
                  ? <CountryFlag regionName={event.homeRegionName}/>
                  : (event.homeLogo && <img src={event.homeLogo} alt={event.homeName}/>)
              }
            </div>:''
          }
          <div className={bem.e('event-title')}>
            {formatEventTitle(event.homeName, isMobile)}
          </div>
        </div>
        <div className={bem.e('event-description')}>
          {showTeamLogos ?
            <div className={bem.e('event-flag')}>
              {
                (event.awayIsNationalTeams && event.awayRegionName)
                  ? <CountryFlag regionName={event.awayRegionName}/>
                  : (event.awayLogo && <img src={event.awayLogo} alt={event.awayName}/>)
              }
            </div>:''
          }
          <div className={bem.e('event-title')}>
            {formatEventTitle(event.awayName, isMobile)}
          </div>
        </div>
      </div>
    </>
  )
}

export default OddsComparisonEventDateAndName;
